module.exports = __webpack_public_path__ + "static/media/location-dot-solid.e25cb056.svg";